import React, { useEffect, useState } from 'react'
import { createProjectRedux } from '../../../redux/create-project-redux/CreateProjectRedux';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import ProfileProjects from '../profile-project/ProfileProjects';
import styles from './ViewAllProjects.module.css'
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { CircularLoader } from '../../../components/common/loaders/CircularLoader';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Stack } from "@mui/material";

const ViewAllProjects = () => {

  const actionDispatch = (dispatch: any) => ({
    getAllMyProjects: (data: any) =>
      dispatch(createProjectRedux.actions.getAllMyProjectsRequest(data)),
    getAllMyCollaboratedProjects: (data: any) =>
      dispatch(createProjectRedux.actions.getAllMyCollaboratedProjectsRequest(data)),
    setCreateProjectState: (data: any) =>
      dispatch(createProjectRedux.actions.setCreateProjectState(data)),
    saveProject: (data: any) =>
      dispatch(createProjectRedux.actions.saveProjectRequest(data)),
  });

  const location = useLocation()
  const navigate = useNavigate()

  const {
    getAllMyProjects,
    getAllMyCollaboratedProjects,
    setCreateProjectState,
    saveProject
  } = actionDispatch(useDispatch());

  const createProjectState = useSelector((state: any) => state.CreateProjectRedux);
  const [pageNo, setPageNo] = useState(1);

  useEffect(() => {
    setCreateProjectState({
      key: "myProjects",
      value: {}
    })
    setCreateProjectState({
      key: "myCollaboratedProjects",
      value: {}
    })
    getProjects(1)
  }, [])

  const getProjects = (pageNo: any) => {
    if (location?.state?.isSelfCreatedProjects) {
      getAllMyProjects({ userId: location?.state?.userId, pageNo: pageNo, pageSize: 9 })
    } else {
      getAllMyCollaboratedProjects({ userId: location?.state?.userId, pageNo: pageNo, pageSize: 9 });
    }
  }

  // const handleSaveProject = (event: any, project: any) => {
  //   event.stopPropagation()
  //   saveProject({
  //     projectId: project?.id
  //   })
  //   if (location?.state?.isSelfCreatedProjects) {
  //     {
  //       const data = createProjectState?.myProjects?.responseData?.projectDetails?.map((projectDetails: any) => project.id === projectDetails.id ? {
  //         ...projectDetails,
  //         isProjectSaved: !projectDetails?.isProjectSaved
  //       } : {
  //         ...projectDetails
  //       })

  //       setCreateProjectState({
  //         key: "myProjects",
  //         value: {
  //           ...createProjectState?.myProjects,
  //           responseData: {
  //             ...createProjectState?.myProjects?.responseData,
  //             projectDetails: data
  //           }
  //         }
  //       })
  //     }
  //   } else {
  //     const data = createProjectState?.myCollaboratedProjects?.responseData?.projectDetails?.map((projectDetails: any) => project.id === projectDetails.id ? {
  //       ...projectDetails,
  //       isProjectSaved: !projectDetails?.isProjectSaved
  //     } : {
  //       ...projectDetails
  //     })

  //     setCreateProjectState({
  //       key: "myCollaboratedProjects",
  //       value: {
  //         ...createProjectState?.myCollaboratedProjects,
  //         responseData: {
  //           ...createProjectState?.myCollaboratedProjects?.responseData,
  //           projectDetails: data
  //         }
  //       }
  //     })
  //   }

  // }

  const handlePageNo = () => {

    if (location?.state?.isSelfCreatedProjects) {
      if (
        createProjectState?.myProjects?.totalPages !== pageNo
        // &&
        // dashboardReduxState?.myProjectsBasedOnStatus?.totalPages
      ) {
        getProjects(pageNo + 1)
        setPageNo(pageNo + 1);
      }
    } else {
      if (
        createProjectState?.myCollaboratedProjects?.totalPages !== pageNo
        // &&
        // dashboardReduxState?.myProjectsBasedOnStatus?.totalPages
      ) {
        getProjects(pageNo + 1)
        setPageNo(pageNo + 1);
      }
    }
  };

  const profileProjects = location?.state?.isSelfCreatedProjects ? createProjectState?.myProjects?.responseData : createProjectState?.myCollaboratedProjects?.responseData


  const handleSaveProject = (event: any, project: any, isCollaborated: any) => {
    event.stopPropagation()
    saveProject({
      projectId: project?.id
    })
    if (isCollaborated) {
      const data = createProjectState?.myCollaboratedProjects?.responseData?.projectDetails?.map((projectDetails: any) => project.id === projectDetails.id ? {
        ...projectDetails,
        isProjectSaved: !projectDetails?.isProjectSaved
      } : {
        ...projectDetails
      })

      setCreateProjectState({
        key: "myCollaboratedProjects",
        value: {
          ...createProjectState?.myCollaboratedProjects,
          responseData: {
            ...createProjectState?.myCollaboratedProjects?.responseData,
            projectDetails: data
          }
        }
      })
    } else {
      const data = createProjectState?.myProjects?.responseData?.projectDetails?.map((projectDetails: any) => project.id === projectDetails.id ? {
        ...projectDetails,
        isProjectSaved: !projectDetails?.isProjectSaved
      } : {
        ...projectDetails
      })

      setCreateProjectState({
        key: "myProjects",
        value: {
          ...createProjectState?.myProjects,
          responseData: {
            ...createProjectState?.myProjects?.responseData,
            projectDetails: data
          }
        }
      })
    }
  }

  console.log(location?.state, "location?.state")
  return (
    <div className={styles["container"]}>

      <Stack className={styles["header"]}>
        <ArrowBackIosNewIcon onClick={() => navigate(-1)} />
        <p>{location?.state?.isSelfCreatedProjects ? "My Collabs" : "Joined Collabs"}</p>
      </Stack>

      <div className={styles["divider"]}></div>

      {
        createProjectState?.isLoading && !profileProjects
          ?
          <CircularLoader /> :

          <div className={styles["main-container"]} id="scrollable-projects">

            <InfiniteScroll
              dataLength={
                profileProjects?.length
                  ? profileProjects?.length
                  : 1
              }
              next={() => handlePageNo()}
              hasMore={true}
              loader={
                createProjectState?.isPaginationLoading && (
                  <Stack
                    sx={{ width: "100%", height: "100px", justifyContent: "center", alignItems: "center" }}
                  >
                    <CircularLoader />
                  </Stack>
                )
              }
              scrollableTarget="scrollable-projects"
            >
              <div className={styles["cards-container"]}>
                {
                  profileProjects?.projectDetails.map(
                    (project: any, index: number) => {
                      return (
                        <ProfileProjects
                          isCollaborated={location?.state?.isSelfCreatedProjects ? false : true}
                          project={project}
                          index={index}
                          isOthersProfile={location?.state?.isOthersProfile}
                          handleSaveProject={handleSaveProject}
                          profileName={project.projectOwnerDetails?.fullName}
                          profilePic={
                            project.projectOwnerDetails?.profilePic
                          }
                          isFollowing={
                            project.projectOwnerDetails?.isFollowing
                          }
                          profileID={project.projectOwnerDetails?.userId}
                        />
                      );
                    }
                  )
                }
              </div>
            </InfiniteScroll>
          </div>
      }
    </div>
  )
}

export default ViewAllProjects